import { useCallback } from "react";
import { getLinkedEquipmentInspections } from "../../api/EquipmentInspections";
import { useEquipmentStore } from "../../store/equipment";

export default function useGetLinkedEquipmentInspections() {
  const setInspectionsForEquipment = useEquipmentStore(
    (state) => state.setInspectionsForEquipment
  );

  const getLinkedInspectionsForEquipment = useCallback(
    async (displayEquipment: string) => {
      const response = await getLinkedEquipmentInspections({
        equipSerialId: displayEquipment,
        equipSerialInd: "e",
      });
      if (!response.isError && Array.isArray(response.data)) {
        setInspectionsForEquipment(displayEquipment, response.data);
      }
      return response;
    },
    [setInspectionsForEquipment]
  );
  return { getLinkedInspections: getLinkedInspectionsForEquipment };
}
